import { spacePath } from "../../../api/endpoints";
import type { ElementKind, Id } from "../../../api/types";

/** Where an element opens: an item has its page, any other kind has the element page. */
export function elementPath(element: { id: Id; kind: ElementKind | string }): string {
  const id = encodeURIComponent(element.id);
  return element.kind === "item" ? `/items/${id}` : `/elements/${id}`;
}

export const editPath = (id: Id): string => `/elements/${encodeURIComponent(id)}/edit`;
export const deliverablePath = (id: Id): string => `/deliverables/${encodeURIComponent(id)}`;
export const chapterPath = (key: string): string => `/chapters/${encodeURIComponent(key)}`;

/** The symbol picker, opened for one element. */
export function symbolsPath(elementId?: Id | null): string {
  return elementId ? `/symbols?element=${encodeURIComponent(elementId)}` : "/symbols";
}

/** The library browser, opened with a search and the element a mapping line is for. */
export function libraryPath(options: { q?: string | null; element?: Id | null } = {}): string {
  const query = new URLSearchParams();
  if (options.q) query.set("q", options.q);
  if (options.element) query.set("element", options.element);
  const text = query.toString();
  return text ? `/library?${text}` : "/library";
}

/** The path of a file in the chapter folder is a chapter; its key is the file name. */
export function chapterKeyOfFile(path: string): string | null {
  const match = /^specification\/chapters\/([^/]+)\.md$/.exec(path);
  return match ? (match[1] ?? null) : null;
}

/** The address of a stored picture (a symbol, a line style) for the space the person works in. */
export function assetUrl(id: Id): string {
  return spacePath("asset", `/api/ws/assets/${encodeURIComponent(id)}`);
}

/** The address of the picture of one page of a document. */
export function pageImageUrl(deliverableId: Id, page: number): string {
  return spacePath("page_image", `/api/ws/deliverables/${encodeURIComponent(deliverableId)}/pages/${page}`);
}
